/**
 * NetworkOverviewPage — the `/network` design.
 *
 * Verbatim render of `network-overview.html` from the
 * trex-full-site-emergent-upgrade zip. CSS / HTML / JS live in
 * `./landing/network-overview/{styles,markup,script}.js`.
 *
 * `wireLinks={true}` because this page's anchors are real app routes
 * (`/contact`, `/network/ledger`, `/network/erc-3643`, `/solutions/*`).
 * External `https://` links and any in-page `#…` anchors are left alone
 * by the interceptor in PageHost.
 *
 * No homepage-specific patches needed here — the page has no WhoFor
 * panels and no monotonic HIW steps.
 */
import { STYLES } from "./landing/network-overview/styles";
import { MARKUP } from "./landing/network-overview/markup";
import { SCRIPT } from "./landing/network-overview/script";
import { PageHost } from "./landing/PageHost";

export function NetworkOverviewHero() {
  return (
    <PageHost
      styles={STYLES}
      markup={MARKUP}
      script={SCRIPT}
      hostClass="trex-network-host"
      wireLinks={true}
      data-testid="network-overview-hero"
    />
  );
}
